import React, { useState } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

interface GalleryImage { url: string; }

interface Props {
    images: GalleryImage[];
    /** Radio de esquina de cada miniatura (por defecto rounded-2xl). */
    itemClassName?: string;
    max?: number;
}

// Grilla de miniaturas + visor a pantalla completa con navegación. Compartida
// entre la página pública del criadero y Adóptame para no duplicar la lógica
// del lightbox en cada contexto.
export const PetGalleryGrid: React.FC<Props> = ({ images, itemClassName = 'rounded-2xl', max = 9 }) => {
    const [index, setIndex] = useState<number | null>(null);
    if (!images || images.length === 0) return null;
    const shown = images.slice(0, max);

    const go = (delta: number) => setIndex(i => i === null ? null : (i + delta + shown.length) % shown.length);

    return (
        <>
            <div className="grid grid-cols-3 gap-2">
                {shown.map((g, i) => (
                    <button key={i} onClick={() => setIndex(i)} className={`aspect-square overflow-hidden ${itemClassName} group`}>
                        <img src={g.url} alt="" loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
                    </button>
                ))}
            </div>

            {index !== null && (
                <div className="fixed inset-0 z-[500] bg-black/90 flex items-center justify-center p-4 animate-in fade-in duration-200" onClick={() => setIndex(null)}>
                    <button onClick={() => setIndex(null)} className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors" aria-label="Cerrar">
                        <X size={20} />
                    </button>
                    {shown.length > 1 && (
                        <button onClick={e => { e.stopPropagation(); go(-1); }} className="absolute left-2 sm:left-4 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors" aria-label="Anterior">
                            <ChevronLeft size={22} />
                        </button>
                    )}
                    <img src={shown[index].url} alt="" className="max-w-full max-h-full object-contain" onClick={e => e.stopPropagation()} />
                    {shown.length > 1 && (
                        <button onClick={e => { e.stopPropagation(); go(1); }} className="absolute right-2 sm:right-4 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors" aria-label="Siguiente">
                            <ChevronRight size={22} />
                        </button>
                    )}
                    {shown.length > 1 && (
                        <span className="absolute bottom-4 text-white/70 text-[11px] font-bold uppercase tracking-widest">{index + 1} / {shown.length}</span>
                    )}
                </div>
            )}
        </>
    );
};

export default PetGalleryGrid;
